import React from "react";
import { NavLink } from "react-router-dom";
import { Home, BarChart3, LineChart, User, LayoutGrid } from "lucide-react";

const items = [
  { to: "/", label: "Home", Icon: Home },
  { to: "/riepilogo", label: "Registro", Icon: BarChart3 },
  { to: "/statistiche", label: "Statistiche", Icon: LineChart },
  { to: "/profilo", label: "Profilo", Icon: User },
  { to: "/altro", label: "Altro", Icon: LayoutGrid },
];

export default function BottomNav() {
  return (
    <nav
      className="fixed left-1/2 -translate-x-1/2 w-full max-w-[430px] z-40"
      style={{
        // iPhone notch / home indicator: scendi sotto il safe-area-inset-bottom
        bottom: "max(0px, env(safe-area-inset-bottom))",
      }}
    >
      <div className="mx-3 mb-3 rounded-[22px] bg-[#00a88a] shadow-[0_10px_30px_-8px_rgba(0,168,138,0.55)] relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent pointer-events-none" />
        <ul className="relative grid grid-cols-5">
          {items.map(({ to, label, Icon }) => (
            <li key={to}>
              <NavLink
                to={to}
                end={to === "/"}
                className={({ isActive }) =>
                  `flex flex-col items-center justify-center py-2.5 gap-0.5 text-white transition-colors ${
                    isActive ? "opacity-100" : "opacity-80 hover:opacity-100"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <span
                      className={`flex items-center justify-center rounded-full transition-all ${
                        isActive
                          ? "bg-white/20 scale-105 shadow-inner"
                          : "bg-transparent"
                      }`}
                      style={{ width: 32, height: 26 }}
                    >
                      <Icon size={18} strokeWidth={2.2} />
                    </span>
                    <span className="text-[10px] font-medium leading-none">
                      {label}
                    </span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
